import React from "react";
import DentalOptions from "../Dental/DentalOptions";
import VisualDentalDisclaimer from "../Disclaimer/VisualDentalDisclaimer";
import CoverageYearField from "../Fields/CoverageYearField";
import StateField from "../Fields/StateField";
import PodiatryMenu from "../Podiatry/PodiatryMenu";
import ChiropracticMenu from "../Podiatry/ChiropracticMenu";
import VisionOptions from "../Visual/VisionOptions";

const VisionDentalFiltersForm = ({ selectedProviderType }: { selectedProviderType: number }) => {
    if (selectedProviderType === 7) {
        return <PodiatryMenu />;
    }
    if (selectedProviderType === 6) {
        return (
            <>
                <CoverageYearField />
                <ChiropracticMenu />
            </>
        );
    }

    return (
        <>
            <VisualDentalDisclaimer/>
            <CoverageYearField />
            <StateField />

            {
                selectedProviderType === 3 && (
                    <DentalOptions />
                )
            }

            {
                selectedProviderType === 4 && (
                    <VisionOptions />
                )
            }
        </>
    )
}

export default VisionDentalFiltersForm;